import type {Document, SearchParams, Sorting} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';
import type {IOnInit} from 'angular';
import type {SearchService} from '../../search/search.service';
import {ngAsync} from 'shared/utils/ng-@decorators';

interface KpDocumentsCarouselComponentBindings {
    searchQuery: string,
    orderBy: Sorting,
    maxCount: number
}

export default class KpDocumentsCarouselComponent implements Component<KpDocumentsCarouselComponentBindings> {
    public static componentName = 'kpDocumentsCarousel';

    public templateUrl = require('./kp-documents-carousel.tpl.ftl');

    public bindings = {
        searchQuery: '@',
        orderBy: '@?',
        maxCount: '@?',
        cache: '@?'
    } as const;

    public controller = KpDocumentsCarouselComponentController;
}

class KpDocumentsCarouselComponentController implements KpDocumentsCarouselComponentBindings, IOnInit {
    public documents: Document[];
    public maxCount: number;
    public orderBy: Sorting;
    public searchQuery: string;
    public cache: string;

    /*@ngInject*/
    protected constructor(private searchService: SearchService) {
    }

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    @ngAsync()
    public async $onInit() {
        const searchParams = {
            qt: this.searchQuery,
            pageSize: this.maxCount || 5,
            cache: this.cache || 'longterm',
            exports: 'portaroRecordNewsParagraph',

        } as SearchParams;

        if (this.orderBy) {
            searchParams.sorting = this.orderBy;
        }
        const searchResult = await this.searchService.search<Document>(searchParams);
        this.documents = searchResult.result.content;
    }


}
